// extracted by mini-css-extract-plugin
export default {"whatsappButton":"whatsappButton_whatsappButton__9s9EL"};